module.exports = __webpack_public_path__ + "static/media/CardCompPLO5.a9dc991a.png";